import { ApiFetch } from '../../../shared/utils/fetch';
import type {
  StorefrontStatus,
  ProvisionInfraResponse,
  GoLiveRequest,
  GoLiveResponse,
} from '../types';

/**
 * Storefront Onboarding API client (PE-1812).
 *
 * Targets the osprey-api BFF (ApiFetch, NOT WatchmanFetch) which proxies the
 * provisioning routes. The board reads per-merchant standup status and dispatches
 * the Terraform infra provisioning workflow per slug.
 */
export const onboardingApi = {
  /** Per-merchant storefront standup status (tenant · infra · deploy). */
  getStatus: (slug: string): Promise<StorefrontStatus> =>
    ApiFetch.get(`/provisioning/storefronts/${slug}/status`),

  /**
   * Dispatch infra provisioning for a merchant — creates its GitHub repo +
   * Cloudflare Pages site via Terraform (the-collective-synergy-ops). Gated
   * server-side on MERCHANT.CREATE (COLLECTIVE_SUPERADMIN-exclusive).
   */
  provisionInfra: (slug: string): Promise<ProvisionInfraResponse> =>
    ApiFetch.post(`/provisioning/storefronts/${slug}/infra`),

  /**
   * Flip a provisioned storefront from DEMO_MODE to live (dispatches the ops
   * go-live workflow: writes `<env>-<SLUG>_DEMO_MODE=false` + redeploys the
   * tenant's Cloudflare Pages project). Refused server-side with 409 unless the
   * tenant is connectable, unless `force` is set. MERCHANT.CREATE-gated.
   */
  goLive: (slug: string, body: GoLiveRequest = {}): Promise<GoLiveResponse> =>
    ApiFetch.post(`/provisioning/storefronts/${slug}/go-live`, body),
};
